import script from "./AlphaPost.vue?vue&type=script&setup=true&lang=js"
export * from "./AlphaPost.vue?vue&type=script&setup=true&lang=js"

import "./AlphaPost.vue?vue&type=style&index=0&id=2660981c&lang=scss"

const __exports__ = script;

export default __exports__